import { render, staticRenderFns } from "./TextEditorTitle.vue?vue&type=template&id=137cf213&scoped=true"
import script from "./TextEditorTitle.vue?vue&type=script&lang=js"
export * from "./TextEditorTitle.vue?vue&type=script&lang=js"
import style0 from "./TextEditorTitle.vue?vue&type=style&index=0&id=137cf213&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137cf213",
  null
  
)

export default component.exports